import html2canvas from 'html2canvas'

interface HtmlToImageOptions {
  compress?: boolean
  targetSize?: number
  minQuality?: number
  scale?: number
}

const DEFAULT_OPTIONS: HtmlToImageOptions = {
  compress: false,
  targetSize: 250 * 1024, // 250KB in bytes
  minQuality: 0.5,
  scale: 3,
}

const compressImage = async (
  dataUrl: string,
  quality: number = 0.8
): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height

      const ctx = canvas.getContext('2d')
      if (ctx) {
        ctx.drawImage(img, 0, 0)
      }

      resolve(canvas.toDataURL('image/png', quality))
    }
    img.src = dataUrl
  })
}

export const htmlToImageString = async (
  targetId: string,
  options: HtmlToImageOptions = {}
) => {
  const opts = { ...DEFAULT_OPTIONS, ...options }

  const element = document.getElementById(targetId)
  if (!element) {
    throw new Error(`Element with id ${targetId} not found`)
  }

  const data = await html2canvas(element, {
    useCORS: true,
    scrollX: 0,
    scrollY: -window.scrollY,
    scale: opts.scale,
  })

  const dataUrl = data.toDataURL('image/png')

  if (opts.compress && opts.targetSize && dataUrl.length > opts.targetSize) {
    let quality = 0.8
    let compressedDataUrl = await compressImage(dataUrl, quality)

    while (
      opts.targetSize &&
      opts.minQuality &&
      compressedDataUrl.length > opts.targetSize &&
      quality > opts.minQuality
    ) {
      quality -= 0.1
      compressedDataUrl = await compressImage(dataUrl, quality)
    }
    return compressedDataUrl
  }

  return dataUrl
}
